import {
  Component,
  EventEmitter,
  forwardRef,
  Input, OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {NgOption} from '@ng-select/ng-select';
import {ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {Gateway} from '@models/adminstration/gateway/gateway';

@Component({
    selector: 'scitis-search-select',
    templateUrl: './search-select.component.html',
    styleUrls: ['./search-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchSelectComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class SearchSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() options: Gateway[] = [];
  @Input() placeholder: string = '';
  @Output() optionSelected = new EventEmitter<Gateway>();
  @Output() searchTermEmit = new EventEmitter<string>();
  @Output() focusOut = new EventEmitter<any>();

  searchControl = new UntypedFormControl('', [Validators.required]);
  selectedOption: Gateway | undefined;

  private searchSubject$: Subject<{ term: string, items: any[] }> = new Subject<{ term: string, items: any[] }>();
  private destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnInit(): void {
    if (this.searchControl) {
      this.searchControl.setValue(this.selectedOption);
    }
    this.searchSubject$
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe(({term}) => {
        if (term) {
          this.searchTermEmit.emit(term);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onSearch(term: { term: string, items: any[] }): void {
    this.searchSubject$.next(term);
  }

  onFocusOut(): void {
    this.focusOut.emit();
  }

  onOptionSelected(option: Gateway): void {
    this.optionSelected.emit(option);
  }

  customSearchFn(_term: string, _item: NgOption): undefined {
    return;
  }

  writeValue(obj: any): void {
  }

  registerOnChange(fn: any): void {
  }

  registerOnTouched(fn: any): void {
  }

}
